"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeEntreeRelationTrads = void 0;
exports.ESubModeEntreeRelationTrads = {
    rdv_distance: "Rendez-vous à distance",
    rdv_physique: "Rendez-vous physique",
};
